import routineReducerFactory from "./routineReducerFactory";
import {fetchFairPoints} from "../actions/routines";

const fairPoints = routineReducerFactory(fetchFairPoints, {data: []});

export default fairPoints;